import { ReactNode } from "react";
import { Tooltip } from "react-migration/components/Tooltip";
import { Theme } from "react-migration/lib/theme/Theme";

export function InsightTooltip({ children }: { children: ReactNode }) {
  return (
    <div className="absolute top-[10px] right-[10px]">
      <Tooltip.Wrapper>
        <Tooltip.Trigger>
          <i
            className={"cursor-pointer pointer-events-auto icon-lt-information-line text-lg text-text-base-secondary-a"}
            data-testid="info-tooltip-trigger"
          />
        </Tooltip.Trigger>
        <Tooltip.Content align="center" side="bottom" theme={Theme.Dark} size="sm">
          <span className="whitespace-normal">{children}</span>
        </Tooltip.Content>
      </Tooltip.Wrapper>
    </div>
  );
}
